import { useEffect, useRef } from "react";
import { FlightScene } from "@/hero/FlightScene";

export const FlightCanvas = ({ trackRef, reduced, onReady, onLoad, audioRef }) => {
  const canvasRef = useRef(null);
  const sceneRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const pointer = [0, 0];
    const getScroll = () => {
      const el = trackRef.current;
      if (!el) return 0;
      const range = el.offsetHeight - window.innerHeight;
      return range > 0 ? Math.min(Math.max(window.scrollY / range, 0), 1) : 0;
    };
    let scene;
    try {
      scene = new FlightScene(canvas, {
        getScroll,
        getPointer: () => pointer,
        reduced,
        onReady,
        onProgress: (p) => {
          if (audioRef?.current) audioRef.current.setPhase(p);
        },
      });
    } catch (e) {
      console.error("[hero] scene construct failed", e);
      return undefined;
    }
    sceneRef.current = scene;
    scene.init().then((splats) => {
      onLoad?.(1);
      onReady?.(splats);
    }).catch((e) => { console.error("[hero] scene failed", e); });
    const onMove = (e) => { pointer[0] = (e.clientX / window.innerWidth) * 2 - 1; pointer[1] = (e.clientY / window.innerHeight) * 2 - 1; };
    const onResize = () => scene.resize();
    const onScroll = () => { if (scene.reduced) scene.renderOnce(); };
    window.addEventListener("pointermove", onMove, { passive: true });
    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onScroll, { passive: true });
    const io = new IntersectionObserver(([en]) => scene.setVisible(en.isIntersecting), { threshold: 0 });
    io.observe(canvas);
    return () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("resize", onResize);
      window.removeEventListener("scroll", onScroll);
      io.disconnect();
      scene.dispose();
      sceneRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { sceneRef.current?.setReduced(reduced); }, [reduced]);

  return (
    <div className="absolute inset-0 bg-[#070A0F]">
      <canvas ref={canvasRef} data-testid="webgl-journey-canvas" className="block h-full w-full" aria-label="Scroll-driven journey: satellite above Earth, through clouds, to an autonomous aircraft at sunset" role="img" />
    </div>
  );
};
